/**
 * DSLBadgeKey
 *
 * Inline legend showing all DSL division badges with their labels.
 * Icons rendered as CSS background-image so the space is reserved
 * immediately — no reflow when images load.
 */

const BADGES = [
  { key: 'mg',          src: '/icons/DSL-MG-Badge.svg',              label: 'Mini-Game' },
  { key: 'animation',   src: '/icons/DSL-Animation-Badge-Test.svg',  label: 'Animation' },
  { key: 'comms',       src: '/icons/DSL-Comms-Badge.svg',           label: 'Communications' },
  { key: 'interactive', src: '/icons/DSL-Interactive-Badge.svg',     label: 'Interactive' },
]

export default function DSLBadgeKey() {
  return (
    <div className="dsl-badge-key">
      {BADGES.map(({ key, src, label }) => (
        <div key={key} className="dsl-badge-key-row">
          <div
            className="dsl-badge-key-icon"
            style={{ backgroundImage: `url(${src})` }}
            aria-label={label}
          />
          <span className="dsl-badge-key-label">{label}</span>
        </div>
      ))}
    </div>
  )
}
